import { useState } from "react";
import PropTypes from "prop-types";

import Confirm from "../Common/Confirm";
import UnarchiveStudent from "./UnarchiveStudent";

import Api from "../../../services/Api";

function UnarchiveStudentModal({
  filter,
  onClose,
  students,
  organizationId,
  setConfirmModal,
  finishCloseModal,
  unarchiveStudents,
}) {
  const [confirm, setConfirm] = useState(false);

  const unarchiveStudentOnClick = async () => {
    const dataMutation = {
      archived: false,
      organizationId,
      students: {
        filter: students?.length > 0 ? null : filter,
        studentIds:
          students?.length > 0
            ? students.map((student) => student.studentId)
            : null,
      },
    };
    await Api.archiveOrUnarchiveStudents(dataMutation);
    setConfirm(true);
    setConfirmModal(true);
  };

  const firstTextConfirmation =
    students?.length > 0 ? (
      <div>
        <p>Great! You have unarchived:</p>
        <div className="flex flex-column mt-6">
          <ul className="ml-4 text-2xl text-black font-semibold">
            {students.map((student) => (
              <li key={student.studentId} className="list-disc list-inside">
                <span>
                  {student.firstName} {student.lastName}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ) : (
      <p>You have unarchived {unarchiveStudents} students</p>
    );

  const secondTextConfirmation = (
    <span className="text-2xl font-medium">
      This change will now be visible to all advisors in your organization.
    </span>
  );

  return (
    <div className="flex flex-col h-full">
      {!confirm ? (
        <UnarchiveStudent
          students={students}
          onClick={unarchiveStudentOnClick}
          finishCloseModal={finishCloseModal}
          unarchiveStudents={unarchiveStudents}
        />
      ) : (
        <Confirm
          onClick={onClose}
          firstText={firstTextConfirmation}
          secondText={secondTextConfirmation}
          buttonText="Go Back to Archive Students"
        />
      )}
    </div>
  );
}

UnarchiveStudentModal.propTypes = {
  filter: PropTypes.shape(),
  organizationId: PropTypes.string,
  deleteStudents: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  setConfirmModal: PropTypes.func.isRequired,
  finishCloseModal: PropTypes.func.isRequired,
  students: PropTypes.arrayOf(PropTypes.shape()),
};

export default UnarchiveStudentModal;
